<template>
  <div class="w-full flex p-4 items-center justify-between flex-grow">
    <div>
      <h5>{{ customerPass.pass.name }} <span class="ml-1 text-sm text-gray-500 dark:text-gray-400">(#{{ customerPass.idCustomerPass }})</span></h5>
      <div class="flex items-center space-x-2">
        <o-chip flat size="xs" square>
          {{ $t('pass.usesRemaining') }}: {{ customerPass.isUnlimitedUse ? $t('pass.unlimited') : customerPass.usesRemaining }}
        </o-chip>
        <o-chip flat size="xs" square>
          {{ customerPass.expires ? $t('pass.expiryDate') + ': ' + $date.format(customerPass.expiryDate * 1000, $date.presets.long) : $t('pass.neverExpires') }}
        </o-chip>
      </div>
    </div>

    <div class="flex items-center">
      <div class="form-item--status mr-4">
        <o-chip v-if="isExpired" flat variant="warning" size="xs" square>
          {{ $t('general.expired') }}
        </o-chip>
        <o-chip v-if="isExpended" flat variant="warning" size="xs" square>
          {{ $t('pass.expended') }}
        </o-chip>
        <o-chip v-if="isPaid" flat variant="success" size="xs" square>
          {{ $t('general.paid') }}
        </o-chip>
      </div>
      <div v-if="Number(customerPass.pass.idLocation) === Number($auth.info.location.idLocation)" class="flex items-center space-x-1">
        <o-tooltip :text="$t('pass.edit')">
          <o-panel-link :path="`/customer/pass/${customerPass.id}`" tag="o-button" flat size="sm" icon="edit" />
        </o-tooltip>
        <o-tooltip v-if="!hasOrder" :text="$t('order.new')">
          <o-button flat size="sm" icon="sale" variant="primary" @click="handleCreateOrder" />
        </o-tooltip>
        <o-tooltip v-if="hasOrder" :text="$t('order.view')">
          <o-panel-link tag="o-button" flat size="sm" icon="sale" :path="`/order/${customerPass.order.idOrder}`" />
        </o-tooltip>
        <o-tooltip :text="$t('general.email')">
          <o-button flat size="sm" icon="email" @click="handleEmail" />
        </o-tooltip>
        <o-tooltip :text="$t('general.delete')">
          <o-button flat size="sm" icon="delete" variant="danger" @click="handleDelete" />
        </o-tooltip>
      </div>
    </div>

    <delete-dialog
      v-if="customerPass"
      ref="deleteDialog"
      :customerPass="customerPass"
    />

    <create-order-dialog
      v-if="customerPass"
      ref="createOrderDialog"
    />
  </div>
</template>

<script setup lang="ts">
import CreateOrderDialog from '@/components/order/actions/CreateOrder.vue'
import DeleteDialog from '@/components/customerPass/actions/Delete.vue'

interface Props {
  customerPass: Record<string, any>
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'email', customerPass: any): void
}>()

const deleteDialog = ref<any>()
const createOrderDialog = ref<any>()

const isValid = computed(() => props.customerPass.isValid)
const isExpired = computed(() => props.customerPass.isExpired)
const isExpended = computed(() => props.customerPass.isExpended)
const isPaid = computed(() => props.customerPass.isPaid)
const hasOrder = computed(() => !!props.customerPass.order)

const handleDelete = () => {
  deleteDialog.value.open(props.customerPass)
}

const handleEmail = () => {
  emit('email', props.customerPass)
}

const handleCreateOrder = () => {
  const customer = props.customerPass.customer
  const date = new Date()
  const items = [props.customerPass]

  const data = {
    customer,
    date,
    items,
  }

  createOrderDialog.value.open(data)
}
</script>
